import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  makeStyles,
  Typography
} from '@material-ui/core'
import ExpandMoreIcon from 'mdi-react/ExpandMoreIcon'
import moment from 'moment'
import { useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import i18n from '../../translations/i18n'

const useStyles = makeStyles({
  Accordion: {
    background: '#E7ECEF',
    borderRadius: '8px'
  },
  panelDetails: {
    display: 'block',
    height: '300px',
    padding: 0,
    overflow: 'hidden'
  },
  panelTitle: {
    background: '#E7ECEF',
    borderRadius: '8px'
  },
  heading: {
    outline: 'none',
    fontFamily: 'CircularBold'
  },
  termsFrame: {
    width: '100%',
    height: '100%',
    border: 'none',
    'box-sizing': 'border-box'
  }
})

interface TermsFrameProps {
  createdAt?: number
}

interface IProps {
  t: i18n.TFunction
}

type ComponentProps = TermsFrameProps & IProps

const TermsFrame = (termsFrameProps: ComponentProps) => {
  const { createdAt } = termsFrameProps

  const classes = useStyles()

  const getTermsDate = useCallback((apartmentDate: number | undefined) => {
    const termsVersions = process.env.REACT_APP_TERMS_VERSIONS?.split(',') || []
    if (!termsVersions.length) {
      return ''
    }
    if (apartmentDate === undefined)
      return termsVersions[termsVersions.length - 1]
    for (const item of termsVersions.reverse()) {
      const date = moment(item, 'YYYYMMDD')
      if (date.isValid() && apartmentDate > date.valueOf()) {
        return item
      }
    }
    return termsVersions[0]
  }, [])

  const getTermsLink = useCallback(
    (apartmentDate: number | undefined) => {
      const frameLink = process.env.REACT_APP_TERMS_URL_TEMPLATE || ''
      return frameLink
        .replace('{language}', i18n.language)
        .replace('{version}', getTermsDate(apartmentDate).toString())
    },
    [getTermsDate]
  )

  return (
    <Grid item xs={12} sm={12}>
      <Accordion className={classes.Accordion}>
        <AccordionSummary
          className={classes.panelTitle}
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography className={classes.heading}>
            {i18n.t('apartment.confirmation.terms.title')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.panelDetails}>
          <iframe
            title='terms'
            className={classes.termsFrame}
            src={getTermsLink(createdAt)}
          />
        </AccordionDetails>
      </Accordion>
    </Grid>
  )
}

export default withTranslation()(TermsFrame) as any
